// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Truck2: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 52"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M61.5 18.5L52 11.4c-.2-.2-.5-.3-.8-.3H40.8V3.3c0-1.3-1-2.3-2.3-2.3H3.2C2 1 .9 2 .9 3.3v36.9c0 1.3 1 2.3 2.3 2.3H8c-.2.6-.3 1.3-.3 2 0 3.5 2.9 6.4 6.4 6.4 3.5 0 6.4-2.9 6.4-6.4 0-.7-.1-1.4-.3-2h23.4c-.2.6-.3 1.3-.3 2 0 3.5 2.9 6.4 6.4 6.4 3.5 0 6.4-2.9 6.4-6.4 0-.7-.1-1.4-.3-2h5.1c.7 0 1.3-.6 1.3-1.3V19.6c-.1-.4-.3-.8-.7-1.1zM3.6 3.7h34.5v36.2H18.4c-1.1-1-2.7-1.7-4.3-1.7-1.7 0-3.2.6-4.3 1.7H3.6V3.7zm10.5 44.6c-2.1 0-3.7-1.7-3.7-3.7 0-2.1 1.7-3.7 3.7-3.7s3.7 1.7 3.7 3.7c0 2.1-1.7 3.7-3.7 3.7zm35.5 0c-2.1 0-3.7-1.7-3.7-3.7 0-2.1 1.7-3.7 3.7-3.7 2.1 0 3.7 1.7 3.7 3.7 0 2.1-1.7 3.7-3.7 3.7zm9.8-8.4h-5.5c-1.1-1-2.7-1.7-4.3-1.7-1.7 0-3.2.6-4.3 1.7h-4.5V13.8h10.1l8.6 6.5v19.6z"/><path d="M49.1 17.1h-4c-.7 0-1.3.6-1.3 1.3v11.4c0 .7.6 1.3 1.3 1.3h10.1c.7 0 1.3-.6 1.3-1.3v-6.3c0-.4-.2-.8-.5-1l-6-5.1c-.3-.2-.6-.3-.9-.3zm4.7 11.4h-7.4v-8.7h2.2l5.2 4.3v4.4z"/></svg>;
};

export default React.memo(Truck2);
